// src/app.ts —— 代理端组合入口（TD-804 / TD-806）：createDcApp + 服务绑定
import { createDcApp, type Dict, type GpApp } from '../../shared/src/dc';
import type { IdleEnv } from '../../shared/src/idle';
import { DOMAINS } from './domains/index';
import { createServices, type AgentGp } from './gp';
import type { AgentState } from './state';

export function shellDefaults(): AgentState['sh'] {
  return { config: null, me: null, loginUser: '', loginPwd: '', loginErr: '', fcp: null, idleLeft: 0 };
}

// idleEnv：缺省取浏览器空闲环境（node 用例为 null，不启用），用例注入假环境
export function createAgentApp(opts: { dev: boolean; apiBase: string; idleEnv?: IdleEnv | null }): GpApp<AgentState> & { gp: AgentGp } {
  let dictOf: () => Dict = () => ({});
  const holder: { gp: AgentGp | null } = { gp: null };
  const app = createDcApp<AgentState, AgentGp>({
    // TD-822：screen 初值恒为 booting（不读 props.startLoggedIn）；boot 结束由 session.established 切 app / fcp，否则切 login
    base: { lang: 'zh', screen: 'booting', page: 'home', modal: null, toast: '', toastId: 0, saving: false, sh: shellDefaults() },
    domains: DOMAINS,
    services: (events) => {
      const g = createServices(events, () => dictOf(), opts.apiBase, opts.idleEnv);
      holder.gp = g;
      return g;
    },
    dev: opts.dev,
  });
  const wrapped: GpApp<AgentState> = {
    ...app,
    didMount(host) {
      holder.gp?.bind(host);
      dictOf = () => app.t(host);
      app.didMount(host);
    },
  };
  if (!holder.gp) throw new Error('services 未初始化');
  return { ...wrapped, gp: holder.gp };
}
